import {BundleWebGroupDataType} from "../../interfaces/bundleWebGroups/BundleWebGroup.type";
import InfoHeader from "../infoHeader/InfoHeader";
import styles from "./BundleWebGroup.module.css";
import BundlePackageGroup from "../bundlePackageGroup/desktop/BundlePackageGroup";
import HeaderGroup from "../headerGroup/HeaderGroup";
import {styleHelper} from "../../helpers/commonFunctions";

export default function BundleWebGroup({
                                                        items,
                                                    }: {
    items: BundleWebGroupDataType[];
}) {
    const item = items[0];
    const description = [item.description];
    const bundles = item.bundles;
    const header = [item.header];
    const dashedSeparator = item.dashedSeparator;
    return (
        <div
            className={`vas-card vas-flex-column vas-gap-3 ${styles.white_border} vas-border-radius vas-pb-3 vas-align-item vas-d-flex vas-w-100`}>
            <div className={`vas-d-flex vas-px-3 vas-pt-3`}>
                <HeaderGroup items={header}/>
            </div>
            <div
                className={`vas-dotted-line vas-p-0 vas-m-0`}
                style={styleHelper({borderColor: dashedSeparator?.color})}
            />
            <div className={`vas-d-flex vas-px-3`}>
                <InfoHeader items={description}/>
            </div>
            <div className={`vas-d-flex vas-px-3 vas-gap-3 ${styles.bundle_group_content}`}>
                {bundles &&
                    bundles.length > 0 &&
                    bundles.map((item, idx) => <BundlePackageGroup data={item} key={idx}/>)}
            </div>
        </div>
    );
}
